import { groq } from 'next-sanity'

export const DownloadQuery = groq`
  _type == "Download" => {
  ...,
            files[]{  
            ...,                                       file{
            ...,
          asset-> {
            _id,
            _type,
            url,
            originalFilename,
            mimeType,
            size,
            ...,
          }
}
}
  }
`
